// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';

import Alerts from 'app/scripts/views/lib/alerts';
import { AttachmentLimitExceededError as LimitExceeded } from 'app/scripts/views/attachment/AttachmentLimitExceededError';
import limitExceededTemplate from 'app/scripts/views/templates/popover_limit_exceeded';

// eslint-disable-next-line no-restricted-imports
import parseURL from 'url-parse';

import Promise from 'bluebird';
import { View } from 'app/scripts/views/internal/view';
import template from 'app/scripts/views/templates/card_attach_links';
import xtend from 'xtend';
import { Analytics } from '@trello/atlassian-analytics';

class AttachLinksView extends View {
  static initClass() {
    this.prototype.viewTitleKey = 'attach links';

    this.prototype.events = { 'click .js-attach:not([disabled])': 'attach' };
  }
  initialize({ links }) {
    this.links = links;

    return this.listenTo(
      this.model.attachmentList,
      'add remove reset',
      this.render,
    );
  }

  render() {
    if (!this.model.canAttach()) {
      if (this.model.isOverLimit('attachments', 'perCard')) {
        this.$el.html(limitExceededTemplate('perCard'));
      } else if (this.model.getBoard().isOverLimit('attachments', 'perBoard')) {
        this.$el.html(limitExceededTemplate('perBoard'));
      }

      return this;
    }

    const entries = Array.from(this.links).map((link) =>
      xtend(link, {
        domain: parseURL(link.url).host,
        attached: this.model.attachmentList.any(
          (att) => att.get('url') === link.url,
        ),
      }),
    );

    Analytics.sendScreenEvent({
      name: 'attachLinkInlineDialog',
      containers: {
        card: {
          id: this.model.id,
        },
        board: {
          id: this.model.getBoard()?.id,
        },
        list: {
          id: this.model.getList()?.id,
        },
        organization: {
          id: this.model?.getBoard()?.getOrganization()?.id,
        },
      },
    });

    this.$el.html(template(entries));
    return this;
  }

  attach(e) {
    const $target = $(e.currentTarget);
    const url = $target.attr('data-url');
    const text = $target.attr('data-text');

    $target.attr('disabled', 'disabled');
    return Promise.fromNode((next) =>
      this.model.uploadUrl({ url, name: text }, next),
    )
      .then(() =>
        Analytics.sendTrackEvent({
          action: 'attached',
          actionSubject: 'link',
          source: 'cardDetailScreen',
        }),
      )
      .catch(LimitExceeded, () =>
        Alerts.show('unable to attach link', 'error', 'linkattachment', 5000),
      );
  }
}

AttachLinksView.initClass();
export { AttachLinksView };
